/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import classnames from "classnames";

import { Actions } from "redux/app_actions";
import Styles from "./Styles.module.scss";
import Bootstrap from "../Bootstrap/Bootstrap.module.scss";
import { useSensor } from "Handlers/ResponsiveHandler";
import { Helmet } from "react-helmet";
import bs from "design-components/Bootstrap/Bootstrap.module.scss";
// import Footer from "../Footer";
import View from "../View";
import { selectActiveRole, selectUser, ISelectUser } from "redux/selectors";
import { stringIsNullOrEmpty } from "app/AppSupport/StringTools";
import { IStore } from "redux/reducer_types";
import { IUserRole } from "app/graphql_types";

declare interface IPage {
    className?: string;
    style?: React.CSSProperties;
    title: string;
    bodyBackgroundColor?: string;
    useFluidContainer?: boolean;
    disableContainer?: boolean;
    showingFooter?: boolean;
    footerHeight?: number;
    pageLanguageSource: "user" | "role";
}

const Page: React.FC<IPage> = (props) => {
    const {
        children,
        className,
        style,
        title,
        // bodyBackgroundColor,
        useFluidContainer,
        disableContainer,
        footerHeight,
        showingFooter,
        pageLanguageSource,
    } = props;

    const dispatch = useDispatch();

    const { screenSize } = useSensor();

    const language = useSelector((state: IStore) => state.app.language);
    const activeRole: IUserRole | undefined = useSelector(selectActiveRole);
    const user: ISelectUser = useSelector(selectUser);

    useEffect(() => {
        if (pageLanguageSource === "user") {
            if (user && !stringIsNullOrEmpty(user.email) && language) {
                if (language !== user.principalLanguage) {
                    dispatch(
                        Actions.requestNewLanguage({
                            language: user.principalLanguage,
                        })
                    );
                }
            }
        } else {
            if (user && !stringIsNullOrEmpty(user.email) && language) {
                const activeRoleLanguage =
                    activeRole &&
                    activeRole.userRoleConfidentialById.rolePreferences &&
                    activeRole.userRoleConfidentialById.rolePreferences
                        .language;
                if (
                    language !== (activeRoleLanguage || user.principalLanguage)
                ) {
                    dispatch(
                        Actions.requestNewLanguage({
                            language:
                                activeRoleLanguage || user.principalLanguage,
                        })
                    );
                }
            }
        }
    }, [user, activeRole, language]);

    // useEffect(() => {
    //     if (bodyBackgroundColor)
    //         document.body.style.backgroundColor = bodyBackgroundColor;
    // }, []);

    const getSizeClass = () => {
        if (screenSize.maxMobile) return "";
        if (screenSize.maxTablet) return `${(Bootstrap as any).tablet}`;
        if (screenSize.maxDesktop) return `${(Bootstrap as any).desktop}`;
        return `${(Bootstrap as any).largeDesktop}`;
    };

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{`${title} :: Pallene`}</title>
            </Helmet>
            <div
                className={classnames(
                    !disableContainer
                        ? useFluidContainer
                            ? bs["container-fluid"]
                            : bs["container"]
                        : "",
                    Styles.pageWidget,
                    getSizeClass(),
                    className
                )}
                style={style}
            >
                {children}
                {showingFooter && footerHeight ? (
                    <View style={{ height: footerHeight }} />
                ) : (
                    <></>
                )}
            </div>
        </>
    );
};

export default Page;
